import { Grid } from "@mui/material";
import { SingleValueCardColor, SingleValueCardType } from "constants/index";
import {
  StrategyReportSingleValueCardDescriptions,
  StrategyReportSingleValueCardLabels,
} from "helpers/constants";
import SingleValueCard from "../SingleValueCard";
import { SummaryCardsState } from "./useSummaryCards";

/** The Summary row's six tiles, read from useSummaryCards. */
const SummaryCardsGrid = ({ summary }: { summary: SummaryCardsState }) => (
  <Grid container spacing={4} columns={{ lg: 12, md: 6, xs: 12 }}>
    <Grid item lg={4} xs={12} md={6}>
      <SingleValueCard
        value={summary.startingValue}
        label={StrategyReportSingleValueCardLabels.STARTING_VALUE}
        description={summary.summaryFooters.startingValue}
        type={SingleValueCardType.CURRENCY}
        color={SingleValueCardColor.PRIMARY}
        onValueChange={summary.setStartingValue}
        unavailableReason={summary.valueCardsReason}
        note={summary.startingValueDateNote}
      />
    </Grid>
    <Grid item lg={4} xs={12} md={6}>
      <SingleValueCard
        value={summary.endingValue}
        label={StrategyReportSingleValueCardLabels.ENDING_VALUE_CARD}
        description={summary.summaryFooters.endingValue}
        type={SingleValueCardType.CURRENCY}
        color={SingleValueCardColor.PRIMARY}
        onValueChange={summary.setEndingValue}
        unavailableReason={summary.valueCardsReason}
        note={summary.endingValueDateNote}
      />
    </Grid>
    <Grid item lg={4} xs={12} md={6}>
      <SingleValueCard
        value={summary.netChange}
        label={StrategyReportSingleValueCardLabels.NET_CHANGE}
        description={summary.summaryFooters.netChange}
        type={SingleValueCardType.CURRENCY}
        color={SingleValueCardColor.PRIMARY}
        onValueChange={summary.setNetChange}
        unavailableReason={summary.valueCardsReason}
      />
    </Grid>
    <Grid item lg={4} xs={12} md={6}>
      <SingleValueCard
        value={summary.timeWeightedReturn}
        label={StrategyReportSingleValueCardLabels.TIME_WEIGHTED_RETURN_CARD}
        description={
          StrategyReportSingleValueCardDescriptions.TIME_WEIGHTED_RETURN
        }
        type={SingleValueCardType.PERCENTAGE}
        color={SingleValueCardColor.PRIMARY}
        onValueChange={summary.setTimeWeightedReturn}
        dimmed={summary.tileDimmed(
          StrategyReportSingleValueCardLabels.TIME_WEIGHTED_RETURN_CARD,
        )}
        unavailableReason={summary.timeWeightedReturnReason}
      />
    </Grid>
    <Grid item lg={4} xs={12} md={6}>
      <SingleValueCard
        value={summary.incomeFigure}
        label={StrategyReportSingleValueCardLabels.INCOME_RECEIVED}
        description={summary.incomeFooter}
        type={SingleValueCardType.CURRENCY}
        color={SingleValueCardColor.PRIMARY}
        onValueChange={summary.handleIncomeChange}
        onClear={
          summary.incomeTile.overridable ? summary.clearIncomeCustom : undefined
        }
        dimmed={summary.incomeTile.dimmed}
        overridable={summary.incomeTile.overridable}
        unavailableReason={summary.incomeTile.unavailableReason}
      />
    </Grid>
    <Grid item lg={4} xs={12} md={6}>
      <SingleValueCard
        value={summary.marginInterestFigure}
        label={StrategyReportSingleValueCardLabels.MARGIN_INTEREST}
        description={StrategyReportSingleValueCardDescriptions.MARGIN_INTEREST}
        type={SingleValueCardType.CURRENCY}
        color={SingleValueCardColor.ERROR}
        onValueChange={summary.handleMarginInterestChange}
        onClear={
          summary.marginInterestTile.overridable
            ? summary.clearMarginInterestCustom
            : undefined
        }
        dimmed={summary.marginInterestTile.dimmed}
        overridable={summary.marginInterestTile.overridable}
        unavailableReason={summary.marginInterestTile.unavailableReason}
      />
    </Grid>
  </Grid>
);

export default SummaryCardsGrid;
